import { MapImageId } from "common/components/map/layers/types";
import { Paper, Typography } from "@mui/material";
import { useFarmExplorer } from "portal/state/store";
import { useTranslation } from "react-i18next";
import { viteImageResolver } from "common/utils/map/imageResolver.vite";
import React, { FC } from "react";

export const BoundaryEditLegend: FC = () => {
  const { t } = useTranslation();
  const { boundaryEdit, pointMove } = useFarmExplorer();

  const icon = (id: MapImageId, label: string): JSX.Element => (
    <div className="flex items-center gap-1">
      <img src={viteImageResolver(id)} alt="" className="h-5 w-5" />
      <Typography className="text-xs">{label}</Typography>
    </div>
  );

  return (
    <Paper className="m-2 px-3 py-2 flex flex-col gap-1 bg-opacity-90">
      <Typography className="text-xs">
        {pointMove?.carrying || boundaryEdit?.carrying
          ? t("views.farms.editBoundary.clickToPlace")
          : t("views.farms.editBoundary.instructions")}
      </Typography>
      <div className="flex flex-row flex-wrap gap-x-4 gap-y-1">
        {icon(
          MapImageId.GpsPoint,
          t("views.farms.editBoundary.legendHandPlaced")
        )}
        {icon(MapImageId.RtkFixed, t("views.farms.fixTypes.rtkFixed"))}
        {icon(MapImageId.RtkFloat, t("views.farms.fixTypes.rtkFloat"))}
      </div>
    </Paper>
  );
};
